// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rate-card-wrapper[data-v-4f410e74]{display:flex;justify-content:center;gap:1.25rem;height:105px}.rate-card-wrapper p[data-v-4f410e74]{margin:0}.divider[data-v-4f410e74]{border-left:1px solid #a9a9d9;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
